import $ from 'jquery';
import Tips from './Tips';

/* ===============================================================
  Like System
=============================================================== */
class Like {
    // Initialize
    constructor() {
        this.likeButton = $('.like-button');
        this.tip = new Tips();
        this.init();
    }

    async init() {
        await this.checkUserLoggedIn();
        this.events();
    }

    // Check if user is logged in
    async checkUserLoggedIn() {
        if (!iranthemeWpData.isUserLoggedIn) {
            console.log('User not logged in - like functionality disabled');
            this.likeButton.addClass('disabled-like');
            return false;
        }
        return true;
    }

    // Events
    events() {
        this.likeButton.on('click', (e) => this.ourClickDispatcher(e));
    }

    // Click like button dispatcher
    ourClickDispatcher(e) {
        if (!iranthemeWpData.isUserLoggedIn) {
            this.tip.createTip('error', 'برای لایک کردن ابتدا وارد سایت شوید.');
            return;
        }

        const currentLikeBox = $(e.target).closest('.like-button');

        if (currentLikeBox.attr('data-exists') === 'yes') {
            this.deleteLike(currentLikeBox);
        } else {
            this.createLike(currentLikeBox);
        }
    }

    // Create like
    async createLike(currentLikeBox) {
        const postId = currentLikeBox.attr('data-post');
        if (!postId) {
            console.error('No post ID found');
            return;
        }

        try {
            const response = await this.makeRequest({
                method: 'POST',
                data: { postID: postId },
            });

            if (response && response.likeId) {
                // Update ALL like buttons with the same post ID
                $(`.like-button[data-post="${postId}"]`).attr({
                    'data-exists': 'yes',
                    'data-like': response.likeId,
                });

                // Update like count for ALL buttons with the same post ID
                this.updateAllLikeCounts(postId, 1);
                console.log(
                    `Like created successfully for post ${postId}:`,
                    response,
                );
            }
        } catch (error) {
            console.error('Error creating like:', error);
            if (error.status === 401) {
                this.tip.createTip(
                    'error',
                    'برای لایک کردن ابتدا وارد سایت شوید.',
                );
            } else if (error.status === 400) {
                console.log('Already liked or invalid post type');
            }
        }
    }

    // Delete like
    async deleteLike(currentLikeBox) {
        const likeId = currentLikeBox.attr('data-like');
        const postId = currentLikeBox.attr('data-post');

        if (!likeId) {
            console.error('No like ID found');
            return;
        }

        try {
            const response = await this.makeRequest({
                method: 'DELETE',
                data: { like: likeId },
            });

            // Update ALL like buttons with the same post ID
            $(`.like-button[data-post="${postId}"]`).attr({
                'data-exists': 'no',
                'data-like': '',
            });

            // Update like count for ALL buttons with the same post ID
            this.updateAllLikeCounts(postId, -1);
            console.log(
                `Like deleted successfully for post ${postId}:`,
                response,
            );
        } catch (error) {
            console.error('Error deleting like:', error);
            if (error.status === 401) {
                this.tip.createTip(
                    'error',
                    'برای لایک کردن ابتدا وارد سایت شوید.',
                );
            } else if (error.status === 403) {
                console.log(
                    'User does not have permission to delete this like',
                );
            }
        }
    }

    // Update like count for ALL buttons with the same post ID
    updateAllLikeCounts(postId, change) {
        const buttons = $(`.like-button[data-post="${postId}"]`);
        let currentCount = 0;

        // Get current count from the first button
        const firstCountElement = buttons.first().find('.like-count');
        if (firstCountElement.length) {
            currentCount = parseInt(firstCountElement.text(), 10) || 0;
        }

        const newCount = currentCount + change;

        // Update all buttons with the new count
        buttons.each(function () {
            const countElement = $(this).find('.like-count');
            if (countElement.length) {
                countElement.text(newCount);
            }
        });

        console.log(
            `Like count updated for post ${postId}: ${currentCount} -> ${newCount}`,
        );
    }

    // Update like count for a single element (kept for backward compatibility)
    updateLikeCount(element, change) {
        const postId = element.attr('data-post');
        if (postId) {
            this.updateAllLikeCounts(postId, change);
        } else {
            const countElement = element.find('.like-count');
            const currentCount = parseInt(countElement.text(), 10) || 0;
            const newCount = currentCount + change;
            countElement.text(newCount);
            console.log(`Like count updated: ${currentCount} -> ${newCount}`);
        }
    }

    // Generic AJAX request handler
    makeRequest({ method, data }) {
        const url = `${iranthemeWpData.restUrl}irantheme/v1/manageLike`;

        return $.ajax({
            url: url,
            type: method,
            data: data,
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', iranthemeWpData.nonce);
            },
        });
    }
}

export default Like;
